import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    SET_TOKEN_STATUS,
    REGISTRATION_STARTED,
    REGISTRATION_SUCCESS,
    REGISTRATION_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    SET_INVITATION_CODE_STARTED,
    SET_INVITATION_CODE_SUCCESS,
    SET_INVITATION_CODE_FAILURE,
    RESEND_EMAIL_STARTED,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAILURE,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    LOGIN_2FA_RESET,
    LOGIN_2FA_VERIFY_STARTED,
    LOGIN_2FA_VERIFY_SUCCESS,
    LOGIN_2FA_VERIFY_FAILURE,
    LOGIN_2FA_REQUIRED
} from "./types";


const initialState = {
    test: false,
    authorizationStatus: !!localStorage.getItem('b-auth-status'),
    tokenStatus: !!localStorage.getItem('b-token'),
    registrationStarted: false,
    registration: false,
    registrationErr: false,
    loginStarted: false,
    login: false,
    loginErr: false,
    invitationCodeStatusStarted: false,
    invitationCodeStatus: false,
    invitationCodeStatusErr: false,
    resendEmailStatusStarted: false,
    resendEmailStatus: false,
    resendEmailStatusErr: false,
    forgotPasswordStatusStarted: false,
    forgotPasswordStatus: false,
    forgotPasswordStatusErr: false,
    resetPasswordStatusStarted: false,
    resetPasswordStatus: false,
    resetPasswordStatusErr: false,
    login2faRequired: false,
    login2faChallengeToken: null,
    login2faExpiresIn: null,
    login2faVerifyStarted: false,
    login2faVerifyStatus: false,
    login2faVerifyErr: false,
};

export function mainReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_AUTHORIZATION_STATUS:
            return {
                ...state,
                authorizationStatus: action.payload
            };
        case SET_TOKEN_STATUS:
            return {
                ...state,
                tokenStatus: action.payload
            };
        case REGISTRATION_STARTED:
            return {
                ...state,
                registrationStarted: true
            };
        case REGISTRATION_SUCCESS:
            return {
                ...state,
                registration: action.payload,
                registrationStarted: false
            };
        case REGISTRATION_FAILURE:
            return {
                ...state,
                registrationErr: action.payload,
                registrationStarted: false
            };
        case LOGIN_STARTED:
            return {
                ...state,
                loginStarted: true,
                loginErr: false,

                login2faVerifyErr: false,
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                login: action.payload,
                loginStarted: false,
                loginErr: false,

                login2faRequired: false,
                login2faChallengeToken: null,
                login2faExpiresIn: null,

                login2faVerifyStarted: false,
                login2faVerifyStatus: false,
                login2faVerifyErr: false,

                tokenStatus: true,
                authorizationStatus: true,
            };

        case LOGIN_FAILURE:
            return {
                ...state,
                loginErr: action.payload,
                loginStarted: false,
            };
        case SET_INVITATION_CODE_STARTED:
            return {
                ...state,
                invitationCodeStatusStarted: true
            };
        case SET_INVITATION_CODE_SUCCESS:
            return {
                ...state,
                invitationCodeStatus: action.payload,
                invitationCodeStatusStarted: false
            };
        case SET_INVITATION_CODE_FAILURE:
            return {
                ...state,
                invitationCodeStatusErr: action.payload,
                invitationCodeStatusStarted: false
            };
        case RESEND_EMAIL_STARTED:
            return {
                ...state,
                resendEmailStatusStarted: true
            };
        case RESEND_EMAIL_SUCCESS:
            return {
                ...state,
                resendEmailStatus: action.payload,
                resendEmailStatusStarted: false
            };
        case RESEND_EMAIL_FAILURE:
            return {
                ...state,
                resendEmailStatusErr: action.payload,
                resendEmailStatusStarted: false
            };
        case FORGOT_PASSWORD_STARTED:
            return {
                ...state,
                forgotPasswordStatusStarted: true
            };
        case FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPasswordStatus: action.payload,
                forgotPasswordStatusStarted: false
            };
        case FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                forgotPasswordStatusErr: action.payload,
                forgotPasswordStatusStarted: false
            };
        case RESET_PASSWORD_STARTED:
            return {
                ...state,
                resetPasswordStatusStarted: true
            };
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordStatus: action.payload,
                resetPasswordStatusStarted: false
            };
        case RESET_PASSWORD_FAILURE:
            return {
                ...state,
                resetPasswordStatusErr: action.payload,
                resetPasswordStatusStarted: false
            };
        case LOGIN_2FA_REQUIRED:
            return {
                ...state,
                loginStarted: false,
                loginErr: false,

                login2faRequired: true,
                login2faChallengeToken: action.payload?.challenge_token || null,
                login2faExpiresIn: action.payload?.expires_in || null,

                login2faVerifyStarted: false,
                login2faVerifyStatus: false,
                login2faVerifyErr: false,

                tokenStatus: false,
                authorizationStatus: false,
            };
        case LOGIN_2FA_VERIFY_STARTED:
            return {
                ...state,
                login2faVerifyStarted: true,
                login2faVerifyErr: false,
            };
        case LOGIN_2FA_VERIFY_SUCCESS:
            return {
                ...state,
                login: action.payload,

                login2faRequired: false,
                login2faChallengeToken: null,
                login2faExpiresIn: null,

                login2faVerifyStarted: false,
                login2faVerifyStatus: action.payload,
                login2faVerifyErr: false,

                loginStarted: false,
                loginErr: false,

                tokenStatus: true,
                authorizationStatus: true,
            };
        case LOGIN_2FA_VERIFY_FAILURE:
            return {
                ...state,
                login2faVerifyStarted: false,
                login2faVerifyErr: action.payload,
            };
        case LOGIN_2FA_RESET:
            return {
                ...state,
                login2faRequired: false,
                login2faChallengeToken: null,
                login2faExpiresIn: null,

                login2faVerifyStarted: false,
                login2faVerifyStatus: false,
                login2faVerifyErr: false,
            };
        default:
            return state;
    }
}

